import React from 'react';
import ReactDOM from 'react-dom/client';
import UniversalDesktop from './UniversalDesktopv2';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <UniversalDesktop />
  </React.StrictMode>,
);